<template>	
	<div class="info-box" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
		<header class="modal-header" id="modalTitle">
			<slot name="header"></slot>
			<button type="button" class="btn-close" v-on:click="close()" aria-label="Close modal">x</button>
		</header>
		<section class="modal-body" id="modalDescription">
			<slot name="body"></slot>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'InfoBox',
		methods: {
			close() {
				this.$emit('close');
			}
		}
	};
</script>

<style lang="scss" scoped>
	.info-box {
		position: fixed;
		top: 10px;		
		left:50%;
		transform: translateX(-50%);
		overflow-x: auto;
		display: flex;
		flex-direction: column;
		border-radius:7px;
		background:#f1faff;
		z-index:200;

		@media only screen and (max-width: 800px) {
			top: 0;
			left: 0;
			width:100%;
			border-radius:0;
			transform:initial;
			padding:10px;
		}
	}

	.modal-header, .modal-body {
		padding: 10px;
	}

	.modal-header {		
		display: flex;
	}

	.modal-header {
		color: #4AAE9B;
		justify-content: space-between;
	}

	.modal-body {
		position: relative;		
	}

	.btn-close {
		border: none;
		font-size: 20px;
		padding: 20px;
		cursor: pointer;
		font-weight: bold;
		color: #38b7ea;
		background: transparent;
		margin-left:20px;
	}

	h1, h2, h3{
		margin:5px 0 0 0;
	}

	.btn-close{
		line-height:23px;
		font-size:33px;
		padding:0;
	}
</style>
